import styled from 'styled-components'

interface IProps {
  isVisible?: boolean
  isInvalid?: boolean
}

export const HelperText = styled.span<IProps>`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  font-weight: 400;
  margin-top: 8px;

  color: ${({ theme, isInvalid }) =>
    isInvalid ? theme.colors.textError : theme.colors.info};
  font-size: 12px;
`
